import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WaitingroomComponent } from './waitingroom/waitingroom.component';

const routes: Routes = [{ path: 'waitingroom', component: WaitingroomComponent, data: { title: 'route.loading' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhitelabelRoutingModule {}
